import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const WHO_TO_PAY_KEY = 'WHO_TO_PAY';

export enum WhoToPayValues {
  MYSELF = 'myself',
  W2 = 'w2',
  CONTRACTORS = 'contractors',
}

const WhoToPay = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="whoToPay"
      id="whoToPay"
      label="Who do you plan to pay with Gusto?"
      helperText="Select all that apply."
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard type="checkbox" aria-label="Myself" value={WhoToPayValues.MYSELF}>
          <CardHeader>
            <Heading className="answer" level={3}>
              Myself
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard type="checkbox" aria-label="W-2 employees" value={WhoToPayValues.W2}>
          <CardHeader>
            <Heading className="answer" level={3}>
              W-2 employees
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard type="checkbox" aria-label="Contractors" value={WhoToPayValues.CONTRACTORS}>
          <CardHeader>
            <Heading className="answer" level={3}>
              Contractors
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default WhoToPay;
